<template>
  <div>
    <div class="t-header">
      <span class="fs22">
        {{ $t("transactionsHistory.title") }}
      </span>
      <RouterLink
        class="t-link"
        to="/transactions"
      >
        {{ $t("transactionsHistory.allTransactions") }}
      </RouterLink>
    </div>
    <ProgressLoader
      v-if="loading"
      mode="indeterminate"
      color="#5AC396"
      size="150px"
    />
    <div v-else>
      <div
        v-if="transactions.length > 0"
        class="t-content"
      >
        <div
          v-if="period.length > 0"
          class="t-period"
        >
          {{ period }}
        </div>
        <LastTransaction
          v-for="(transaction, index) in transactions"
          :key="index"
          v-bind="transaction"
        />
      </div>
      <div
        v-else
        class="t-empty"
      >
        <img
          class="t-image"
          src="/img/dashboard/not_found_tr.svg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import LastTransaction from "@/components/lastTransactions/LastTransaction.vue";
import moment from "moment/moment";
import ProgressLoader from "@/loaders/progress-bar";
import { iconLink } from "@/help/transactionHelper.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TransactionsHistory",
  components: {
    LastTransaction,
    ProgressLoader
  },
  data() {
    return {
      loading: true,
      addressEth: null,
      userIRI: "",
      transactions: []
    };
  },
  computed: {
    ...mapGetters({
      ethAddresses: "ethAddresses",
      checkProfile: "profile/checkProfile"
    }),

    period() {
      if (!this.transactions.length) {
        return this.$t("transactionsHistory.none");
      }
      else {
        if (
          this.transactions.length &&
          moment(this.transactions[0]?.createdAt).format("DD.MM.YYYY") ==
            moment().format("DD.MM.YYYY")
        ) {
          return this.$t("transactionsHistory.today");
        }
        else if (
          moment(this.transactions[0]?.createdAt).format("DD.MM.YYYY") ==
          moment().subtract(1, "days").format("DD.MM.YYYY")
        ) {
          return this.$t("transactionsHistory.yesterday");
        }
        else {
          return "";
        }
      }
    }
  },

  watch: {
    async checkProfile() {
      await this.getTransactions(true);
    }
  },

  async mounted() {
    this.userIRI = `/api/users/${this.$auth.user().id}`;
    await this.getTransactions();
  },

  methods: {
    ...mapActions({
      getTransactionsPage: "getTransactionsPage"
    }),

    async getTransactions(reload = false) {
      if (!reload) {
        this.loading = true;
      }

      const resp = await this.getTransactionsPage({
        pageId: 1,
        itemsPerPage: 3,
        sort: "desc",
        userId: this.$auth.user().id
      });
      const data = resp?.data;
      if (!data) {
        this.loading = false;
        return;
      }

      if (reload) {
        this.transactions = [];
      }

      _.forEach(data, (transaction) => {
        if (!transaction?.auToken) {
          this.loading = false;
          return;
        }

        _.forEach(this.ethAddresses, (eth) => {
          if (
            _.toLower(eth.value) === _.toLower(transaction.addressFrom)
          ) {
            this.addressEth = transaction.addressTo;
          }
          if (_.toLower(eth.value) === _.toLower(transaction.addressTo)) {
            this.addressEth = transaction.addressFrom;
          }
          if (this.userIRI == _.toLower(transaction?.fromUser)) {
            this.addressEth = transaction?.addressFrom;
          }
          if (transaction.addressFrom == 0) {
            this.addressEth = transaction.addressTo;
          }
        });
        this.transactions.push({
          icon: iconLink(transaction),
          name: this?.addressEth
            ? this.addressEth.slice(0, 4) + "..." + this.addressEth.slice(-4)
            : this.$t("transactions.unspecified"),
          addressFrom: transaction.addressFrom,
          addressTo: transaction.addressTo,
          addressEth: this.addressEth,
          amount: transaction.amount,
          isConfirmed: transaction.isConfirmed,
          cardType: moment(transaction.createdAt).format("DD.MM.YYYY HH:mm:ss"),
          isRefill:
            _.toLower(this.ethAddresses[0]?.value) === _.toLower(transaction?.addressTo),
          transactionType: transaction?.methodName,
          decimals: transaction?.auToken?.decimals,
          indent: transaction?.auToken?.indent,
          mnemonic: transaction?.auToken?.mnemonicEng,
          createdAt: transaction.createdAt,
          hash: transaction.hash,
          projectId: transaction?.auCapital?.id ?? null,
          projectName:
            process.env.VUE_APP_PROJECT_TITLE_TYPE == "name"
              ? transaction?.auCapital?.tokenBase?.nameEng ?? ""
              : transaction?.auCapital?.tokenBase?.mnemonicEng ?? "",
          isVoting: transaction?.auCapital?.projectType === "voting"
        });
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.t-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.t-link {
  color: #279063;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
}
.t-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.t-period {
  font-size: 12px;
}
.t-metamask {
  color: var(--text-color);
  text-decoration: underline;
}
.t-empty {
  display: flex;
  height: content-box;
  justify-content: center;
  align-items: center;
  .t-image {
    width: 380px;
    height: 194px;
    @media screen and (max-width: 900px) {
      width: 200px;
    }
  }
}
</style>
